module.exports = __webpack_public_path__ + "img/af.cdc9de92.svg";